import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import getDate from 'date-fns/getDate';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';

@Directive({
  selector: '[appDateMaskValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DateMaskValidatorDirective,
      multi: true
    }
  ],
  standalone: false
})
export class DateMaskValidatorDirective implements Validator {
  @Input() minYears: number;
  @Input() maxYears: number;
  @Input() dateFormat: string;

  /**
   *
   * @param control AbstractControl
   *
   * Validates the date if its 18yr old
   * returns  { [key: string]: any } | null
   */
  validate(control: AbstractControl): { [key in 'DateInvalid' | 'DateNotInRange']?: boolean } | null {
    if (!control.value) {
      return null;
    }

    const today = new Date();
    const birthDate = parse(control.value, this.dateFormat, today);

    if (!isValid(birthDate)) {
      return { DateInvalid: true };
    }

    let yearsDiff = today.getFullYear() - getYear(birthDate);
    const m = today.getMonth() - getMonth(birthDate);

    if (m < 0 || (m === 0 && today.getDate() < getDate(birthDate))) {
      yearsDiff--;
    }

    if (yearsDiff < this.minYears || yearsDiff > this.maxYears) {
      return { DateNotInRange: true };
    }

    return null;
  }
}
